import type { Board } from '../engine/board';
import { cellsOf, EXIT_ROW, SIZE } from '../engine/level';

export class Renderer {
  readonly ctx: CanvasRenderingContext2D;
  dpr = 1; w = 0; h = 0; ox = 0; oy = 0; cw = 0;
  constructor(readonly canvas: HTMLCanvasElement) { this.ctx = canvas.getContext('2d')!; }
  resize(w: number, h: number, dpr: number) {
    this.dpr = Math.min(dpr, 2); this.w = w; this.h = h;
    this.canvas.width = Math.round(w * this.dpr); this.canvas.height = Math.round(h * this.dpr);
    this.canvas.style.width = `${w}px`; this.canvas.style.height = `${h}px`;
    const side = Math.floor(Math.min(w, h) * 0.92);
    this.cw = side / SIZE; this.ox = (w - side) / 2; this.oy = (h - side) / 2;
  }
  /** 픽셀 → 칸 좌표(실수). */
  toCell(x: number, y: number): [number, number] { return [(x - this.ox) / this.cw, (y - this.oy) / this.cw]; }

  draw(b: Board) {
    const { ctx, cw, ox, oy } = this;
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    ctx.fillStyle = '#101010'; ctx.fillRect(0, 0, this.w, this.h);
    // 판 + 출구
    ctx.fillStyle = '#1c1c1c'; ctx.fillRect(ox, oy, cw * SIZE, cw * SIZE);
    ctx.strokeStyle = '#2a2a2a'; ctx.lineWidth = 1; ctx.beginPath();
    for (let i = 0; i <= SIZE; i++) {
      const x = Math.round(ox + i * cw) + 0.5, y = Math.round(oy + i * cw) + 0.5;
      ctx.moveTo(x, oy); ctx.lineTo(x, oy + cw * SIZE); ctx.moveTo(ox, y); ctx.lineTo(ox + cw * SIZE, y);
    }
    ctx.stroke();
    ctx.strokeStyle = '#555'; ctx.lineWidth = 3; ctx.beginPath();
    ctx.rect(ox - 1.5, oy - 1.5, cw * SIZE + 3, cw * SIZE + 3); ctx.stroke();
    // 출구 틈
    ctx.fillStyle = '#101010'; ctx.fillRect(ox + cw * SIZE - 2, oy + EXIT_ROW * cw + 4, 8, cw - 8);
    ctx.fillStyle = '#d9433b'; ctx.font = `${Math.round(cw * 0.5)}px sans-serif`; ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.fillText('›', ox + cw * SIZE + 8, oy + (EXIT_ROW + 0.5) * cw);
    // 블록
    b.blocks.forEach((blk, i) => {
      const dragging = b.drag?.i === i;
      const off = dragging ? b.drag!.offset : 0;
      const cells = cellsOf(blk);
      const r0 = cells[0]![0] + (blk.dir === 'v' ? off : 0), c0 = cells[0]![1] + (blk.dir === 'h' ? off : 0);
      const wCells = blk.dir === 'h' ? blk.len : 1, hCells = blk.dir === 'v' ? blk.len : 1;
      const pad = cw * 0.05;
      const x = ox + c0 * cw + pad, y = oy + r0 * cw + pad, ww = wCells * cw - pad * 2, hh = hCells * cw - pad * 2;
      ctx.fillStyle = blk.red ? (dragging ? '#ef5a50' : '#d9433b') : (dragging ? '#dba065' : '#c98b4a');
      ctx.strokeStyle = blk.red ? '#8f2a24' : '#8a5a2a'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.roundRect(x, y, ww, hh, cw * 0.18); ctx.fill(); ctx.stroke();
      // 나뭇결 한 줄
      ctx.strokeStyle = 'rgba(0,0,0,.15)'; ctx.lineWidth = 1.5; ctx.beginPath();
      if (blk.dir === 'h') { ctx.moveTo(x + 8, y + hh * 0.5); ctx.lineTo(x + ww - 8, y + hh * 0.5); } else { ctx.moveTo(x + ww * 0.5, y + 8); ctx.lineTo(x + ww * 0.5, y + hh - 8); }
      ctx.stroke();
    });
  }
}
